import { render, staticRenderFns } from "./EqifySmallTitle.vue?vue&type=template&id=387c3218&scoped=true"
import script from "./EqifySmallTitle.vue?vue&type=script&lang=ts"
export * from "./EqifySmallTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387c3218",
  null
  
)

export default component.exports